import styles from "./LessonCompleteSnackbar.module.scss";

type Props = {
  mode: "countdown" | "undo";
  secondsRemaining?: number;
  onUndo?: () => void;
};

function LessonCompleteSnackbar(props: Props) {
  const { mode, secondsRemaining = 0, onUndo } = props;

  if (mode === "countdown") {
    return (
      <div className={styles.snackbar} role="status" aria-live="polite">
        Lesson will be marked as complete in {secondsRemaining}...
      </div>
    );
  }

  return (
    <div className={styles.snackbar} role="status" aria-live="polite">
      Not ready yet?{" "}
      <button type="button" className={styles.undoLink} onClick={onUndo}>
        Undo completion
      </button>
    </div>
  );
}

export default LessonCompleteSnackbar;
